<script setup>
import { inject } from 'vue'

const cartStore = inject('cartStore')
</script>

<template>
    <a href="/winkelwagen" title="Winkelwagen" class="flex flex-col rounded-full items-center justify-center tracking-wide relative">
        <span v-if="cartStore.data.lines.length > 0" class="absolute flex justify-center items-center size-4 bg-white rounded-full text-xs text-red-500 font-semibold top-0 -right-1.5 lg:right-5" v-html="cartStore.data.lines.length"></span>
        <icon name="cart" class="size-6 flex-none text-white"></icon>
        <div class="hidden lg:block mt-1 text-white text-xs font-semibold">Winkelwagen</div>
    </a>
</template>
